import { ActivationCodesRepository } from 'common/repositories/index';
import eventManager from 'common/services/-RFC.eventManager';

angular.module('listeners')
    .service('ActivationCodesListener', () => {

        eventManager.subscribe('socket:activation-codes', (response) => {

            if (response.verb === 'POST') {

                ActivationCodesRepository.add(response.payload.data);

            }

            // This method was removed because we need to test all scenarios
            // if (response.verb === 'PUT') {

            //     ActivationCodesRepository.update(response.payload.data);

            // }

        });

    });



// WEBPACK FOOTER //
// ./scripts/common/listeners/activationCodes.js